import axios from "@/axios";
import * as types from '@/store/mutation-types'

export default {
    namespaced: true, 
    state: {
        users: []
    },
    actions: {
        fetchAll({ commit }) {
            return axios.get('/User').then(({ data }) => {
                commit(types.USERS, data)
                return data
            })
        },

        create({ commit }, { employeeId, roleId, isAdmin, username, password, userType, isActive }) {
            return axios.post('/User', { employeeId, roleId, isAdmin, username, password, userType, isActive }).then((data) => {
                return data
            })
        },

        update({ commit }, { id, username, password, userType }) {
            return axios.put(`/User/${id}`, {  username, password, userType }).then((data) => {
                return data
            })
        },

        delete({ commit }, { id }) {
            return axios.delete(`/User/${id}`).then((data) => {
                return data
            })
        }
    },

    mutations: {
        [types.USERS](state, users) {
            state.users = users
        }
    },

    getters: {
        getById: state => id => state.users.find(c => c.id === id)
    }
}